import { useContext } from 'react'
import { NpsContext } from './NpsContext'

export const useNps = () => {
    const context = useContext(NpsContext)
    if (!context) {
        throw new Error('useNps must be used within NpsProvider')
    }
    return {
        triggerNps: context.triggerNps,
    }
}

// Internal hook used by NpsModal for full state access. Not part of the public API.
export const useNpsInternal = () => {
    const context = useContext(NpsContext)
    if (!context) {
        throw new Error('useNpsInternal must be used within NpsProvider')
    }
    return context
}
